var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badges"},_vm._l((_vm.badges),function(badge,index){return _c('div',{key:index,staticClass:"badge",class:badge.style},[_vm._v(_vm._s(badge.symbol))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }